/**
 * @author: dongjing
 * @file: 圈子和团队详细信息数量展示
 * @Date: 2019-12-16 12:19:13
 * @LastEditors: dongjing
 * @LastEditTime: 2019-12-17 14:23:31
 */
import React from 'react';
import './SFCNumberShow.less';
import { IconFont } from '../..';

export interface ISFCNumberShowProps {
  /** 成员数量 */
  member: number;
  /** 文章数量 */
  articleNum: number;
  /** 问答数量 */
  askNum: number;
  /** 是否是圈子 */
  circle?: boolean;
}
type Props = ISFCNumberShowProps;

export function SFCNumberShow(props: Readonly<Props>) {
  const { member, articleNum, askNum, circle = true } = props;
  return (
    <div className="common-presenter k-common-number-show">
      <IconFont type="icon-peo" className="list-icon" />
      {member}&nbsp;个{circle ? '成员' : '粉丝'}
      <span className="shu"></span>
      <IconFont type="icon-article" className="list-icon" />
      {articleNum}&nbsp;篇文章
      <span className="shu"></span>
      <IconFont type="icon-ask" className="list-icon" />
      {askNum}&nbsp;个提问
    </div>
  );
}

export default SFCNumberShow;
